<template>
  <div class="h-100 d-flex flex-column justify-center align-center">
    <div :class="containerClass">
      <div class="d-flex justify-end w-100 mb-2">
        <div class="w-100 d-flex flex-column align-center">
          <h1 class="mb-4 indigo--text">Store Search</h1>
          <v-text-field
              v-model="searchString"
              placeholder="Search store by store name or account address"
              hide-details
              filled
              color="indigo darken-3"
              class="w-100"
              @keyup.enter="onSearchHandle"
          >
            <template v-slot:[`append`]>
              <div class="cursor-pointer" @click="onSearchHandle">
                <v-icon>
                  mdi-magnify
                </v-icon>
              </div>
            </template>
          </v-text-field>
        </div>
      </div>

      <div class="text-center mt-8">
        <v-progress-circular
            v-if="isSearching"
            indeterminate
            color="indigo lighten-3"
        ></v-progress-circular>
      </div>

      <div class="d-flex flex-wrap justify-center">
        <v-alert
            text
            type="info"
            class="mt-4"
            v-if="JSON.stringify(stores) === '[]'"
        >
          No store with the search name or search account found
        </v-alert>
        <StoreCard
            class="mx-2"
            storeName="Decentral Store"
            storeAccount="0x33cf1099bb805e792e98a508435ab327fa8018fd"
            storeSummary="Empowering eCommerce businesses to build customer loyalty schemes with NFT and web3 integration"
            transparent
            verified
        ></StoreCard>

        <StoreCard
            class="mx-2"
            v-for="(store, index) in stores"
            :key="index"
            :storeName="store.name"
            :storeAccount="store.account"
            :storeSummary="store.summary"
        ></StoreCard>
      </div>
    </div>
  </div>
</template>

<script>
import backendCall from "@/lib/backendCall";
import StoreCard from "@/views/StoreSearch/Component/StoreCard";

export default {
  name: "StoreSearch",
  components: {
    StoreCard
  },
  computed: {
    containerClass() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'container'
        case 'sm': return 'container-sm'
        case 'md': return 'container-md'
        case 'lg': return 'container-md'
        case 'xl': return 'container-md'
        default: return 'container-md'
      }
    }
  },
  data(){
    return {
      searchString: "",
      stores: null,
      isSearching: false
    }
  },
  methods: {
    async onSearchHandle(){
      this.isSearching = true
      try {
        const res = await backendCall.store.getStores(this.searchString)
        if (res.status === 1) {
          if (res.data !== null){
            this.stores = res.data
          }else {
            this.stores = []
          }
        }
      }catch (e) {
        console.error(e)
      }finally {
        this.isSearching = false
      }

    }
  }
}
</script>

<style scoped>
.container {
  width: 90%
}

.container-sm {
  width: 85%;
}

.container-md {
  width: 65%
}
</style>